import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  padding: 2rem;
  height: calc(100vh - 4rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Card = styled(motion.div)`
  background: #ffffff;
  border: 1px solid rgba(0, 102, 255, 0.1);
  border-radius: 16px;
  padding: 3rem;
  width: 80%;
  max-width: 800px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 102, 255, 0.05);
  
  &::before {
    content: '';
    position: absolute;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: var(--primary);
    filter: blur(100px);
    opacity: 0.05;
    top: -50px;
    right: -50px;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  // font-family: 'Manrope', sans-serif;
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: var(--text-secondary);
  max-width: 600px;
  margin: 0 auto 2rem auto;
  line-height: 1.6;
`;

const IconContainer = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 24px;
  background: rgba(0, 102, 255, 0.03);
  border: 2px solid rgba(0, 102, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  font-size: 3rem;
  color: var(--primary);
  font-family: 'Manrope', sans-serif;
`;

const ComingSoonTag = styled.div`
  background: rgba(0, 102, 255, 0.1);
  color: var(--primary);
  padding: 0.5rem 1rem;
  border-radius: 30px;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 1rem;
  display: inline-block;
`;

const getPageIcon = (title) => {
  const titleLower = title.toLowerCase();
  
  if (titleLower.includes('mission') || titleLower.includes('control')) return '🎮';
  if (titleLower.includes('claims') || titleLower.includes('triage')) return '🏥';
  if (titleLower.includes('underwriting')) return '📝';
  if (titleLower.includes('document')) return '📄';
  if (titleLower.includes('fraud')) return '🔍';
  if (titleLower.includes('agent') || titleLower.includes('studio')) return '🤖';
  if (titleLower.includes('personas')) return '👤';
  if (titleLower.includes('model')) return '🧠';
  if (titleLower.includes('performance')) return '📊';
  if (titleLower.includes('knowledge')) return '📚';
  if (titleLower.includes('data')) return '🗃️';
  if (titleLower.includes('prompt')) return '💬';
  if (titleLower.includes('pipelines')) return '⚙️';
  if (titleLower.includes('security') || titleLower.includes('governance')) return '🔒';
  if (titleLower.includes('observability')) return '👁️';
  if (titleLower.includes('feedback')) return '🔄';
  
  return '🚀';
};

const EmptyPage = ({ title, description }) => {
  return (
    <Container>
      <Card
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <ComingSoonTag>Coming Soon</ComingSoonTag>
        <IconContainer>
          {getPageIcon(title)}
        </IconContainer>
        <Title>{title}</Title>
        <Description>{description}</Description>
        
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <svg width="100" height="4" viewBox="0 0 100 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="100" height="4" rx="2" fill="url(#paint0_linear)" />
            <defs>
              <linearGradient id="paint0_linear" x1="0" y1="0" x2="100" y2="0" gradientUnits="userSpaceOnUse">
                <stop stopColor="#0066FF" />
                <stop offset="1" stopColor="#00D4FF" />
              </linearGradient>
            </defs>
          </svg>
        </motion.div>
      </Card>
    </Container>
  );
};

export default EmptyPage;
